import { render, staticRenderFns } from "./ParallaxGallery.vue?vue&type=template&id=14455d0c&scoped=true&"
import script from "./ParallaxGallery.vue?vue&type=script&lang=js&"
export * from "./ParallaxGallery.vue?vue&type=script&lang=js&"
import style0 from "./ParallaxGallery.vue?vue&type=style&index=0&id=14455d0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14455d0c",
  null
  
)

export default component.exports